import { SelectedItems, TmdxChip } from '@ds';
import { SelectItemType } from '@/types';

export const CoverageRenderValue = ({
  items,
  onRemove,
}: {
  items: SelectedItems<SelectItemType>;
  onRemove: (val: string) => void;
}) => {
  const coverageItems = items.map((item) => item.data as SelectItemType);
  return (
    <div className="flex flex-wrap gap-2">
      {coverageItems.map((item) => (
        <TmdxChip key={item.value} size="sm" color="tertiary" onClose={() => onRemove(item.value)}>
          {item.name}
        </TmdxChip>
      ))}
    </div>
  );
};
